import { useState } from 'react';
import './angular.component.css';
import { BSCourse } from '../bscourse/bscourse.component';
import { CSSCourse } from '../csscourse/csscourse.component';
import { HtmlCourse } from '../htmlcourse/htmlcourse.component';
import { JSCourse } from '../jscourse/jscourse.component';

export function AngularCourse() {

	const [showAngularSetup, setShowAngularSetup] = useState(false);
	const [showAngularCourse, setShowAngularCourse] = useState(true);
	const [showJSCourse, setShowJSCourse] = useState(false);
	const [showHTMLCourse, setShowHTMLCourse] = useState(false);
	const [showCSSCourse, setShowCSSCourse] = useState(false);
	const [showBSCourse, setShowBSCourse] = useState(false);

	return (
		<>
			{/* <iframe src="../pages/angular.html" className='ac-frame'></iframe> */}
			<main id="main" className="site-main container ang-course" role="main">
				<br></br>
				<br></br>
				<article className='angular-course'>
					<div>
						<div className="c-content">
							<span>
								<h3 className='ac-header'>
									Angular Fullstack Course:
								</h3>
								<p className='ac-m-5'>
									<span className='ac-m-c'>
										<span className='ac-f-1'>Promising Hands On Expertise with course completion</span>
										+ Real time Project</span>
								</p>
								<ul className='ac-d-flex'>
									<div className='ac-flex-item'>
										<li>Forms</li>
										<li>Validations</li>
										<li>Menus</li>
										<li>Inline grids</li>
										<li>Routing</li>
										<li>Time Sheet</li>
									</div>
									<div className='ac-flex-item'>
										<li>Popup</li>
										<li>Comm. b/w pages</li>
										<li>Shared Files</li>
										<li>Layouts</li>
										<li>Chat box</li>
										<li>Dynamic controls</li>
									</div>
								</ul>
							</span>
						</div>
					</div>
				</article>

				<article>
					<div onClick={()=>{setShowAngularSetup(!showAngularSetup)}}>
						<header className="entry-header">
							<h1 className="entry-title">
								<span>Angular Setup</span>
								<span className="fa-caret-down-1"></span>
							</h1>
						</header>
					</div>
					{showAngularSetup&&<div id="angularsetup">
						<iframe src="https://krishnachaitanyav.wordpress.com/angular-setup-installation/"
							className='ac-frame'></iframe>
					</div>}
				</article>

				<article id="post-144" className="post-144 page type-page status-publish hentry">
					<div onClick={()=>{setShowAngularCourse(!showAngularCourse)}}>
						<header className="entry-header">
							<h1 className="entry-title">
								<span>Angular Syllabus</span>
								<span className="fa-caret-down-1"></span>
							</h1>
						</header>
					</div>
					{showAngularCourse && <div className="entry-content" id="angularcontent">
						<p><strong>ECMA Script 6</strong></p>

						<ul>
							<li>Classes</li>
							<li>Arrow Functions</li>
							<li>Variables (let, const, var)</li>
							<li>Data Types</li>
							<li>Destructuring</li>
							<li>Modules</li>
							<li>Ternary Operator</li>
							<li>Spread Operator</li>
							<li>ES5 vs ES6</li>
							<li>ES6 Features</li>
						</ul>
						<p data-adtags-visited="true"><strong>Topic 1:</strong> <strong>Angular Introduction</strong></p>
						<ul>
							<li>Angular History</li>
							<li>Angular Versions</li>
							<li>Angular Features</li>
							<li>Single Page Application</li>
						</ul>
						<p data-adtags-visited="true"><strong>Topic 2:</strong> <strong>Angular Environment setup</strong></p>
						<ul>
							<li>Setup Angular IDE</li>
							<li>Setup Angular Project</li>
							<li>Angular Architecture</li>
						</ul>
						<p data-adtags-visited="true"><strong>Topic 3: Creating Angular project</strong></p>
						<ul>
							<li>Create first angular project</li>
							<li>Angular folder Structure</li>
							<li>Angular building blocks</li>
						</ul>
						<p data-adtags-visited="true"><strong>Topic 4: Angular Components</strong></p>
						<ul>
							<li>
								Angular Templates
								<li>Internal</li>
								<li>External</li>
							</li>
							<li>
								Angular Template Styles
								<ul>
									<li>Internal</li>
									<li>External</li>
								</ul>
							</li>
							<li>Metadata</li>
						</ul>
						<p className="inline-ad-slot ac-module" id="inline-ad-0" data-adtags-width="740" data-adtags-visited="true"></p>
						<p data-adtags-visited="true"><strong>Topic 5: Angular Modules</strong></p>
						<ul>
							<li>Root Module</li>
							<li>Feature Module</li>
							<li>Module definition&nbsp;</li>
							<li>Module configuration</li>
						</ul>
						<p><strong>Topic 6: Angular Data Binding</strong></p>
						<ul>
							<li>Interpolation</li>
							<li>Property Bindings</li>
							<li>Expressions&nbsp;</li>
							<li>Event Bindings and Statements</li>
							<li>Grid Data binding</li>
							<li>Handling Null Values with the Safe-Navigation Operator</li>
							<li>Hiding and Showing Content</li>
							<li>Hiding Content with the [Hidden] Binding</li>
							<li>
								Styling Components
								<ul>
									<li>ngClass&nbsp;</li>
									<li>ngStyle</li>
								</ul>
							</li>
						</ul>
						<p><strong>Topic 7: Angular Services</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Dependency Injection</li>
							<li>
								Create service
								<ul>
									<li>Global</li>
									<li>Local</li>
								</ul>
							</li>
							<li>
								Inject service
								<ul>
									<li>Root</li>
									<li>Module</li>
								</ul>
							</li>
							<li>Reusable Srvices</li>
						</ul>
						<p><strong>Topic 8: Angular Nested Component</strong></p>
						<ul>
							<li>Communicating with Child Components Using @Input</li>
							<li>Communicating with Parent Components Using @Output</li>
							<li>Event Emitter</li>
							<li>View Child</li>
							<li>Using Template Variables to Interact with Child Components</li>
						</ul>
						<p><strong>Topic 9: Angular Directives</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Types of directives</li>
							<li>Built-in directives</li>
							<li>Custom directives</li>
						</ul>
						<p><strong>Topic 10: Angular Pipes</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Sync and async Pipes</li>
							<li>Built-in Pipes</li>
							<li>Custom Pipes</li>
						</ul>
						<p><strong>Topic 11: Angular Life cycle Hooks</strong></p>
						<ul>
							<li>Constructor</li>
							<li>
								Initialization
								<ul>
									<li>Component</li>
									<li>View</li>
									<li>Content</li>
								</ul>
							</li>
							<li>
								Check
								<ul>
									<li>Component</li>
									<li>View</li>
									<li>Content</li>
								</ul>
							</li>
							<li>Changes</li>
							<li>Destroy</li>
							<li>Execution Process</li>
						</ul>
						<p><strong>Topic 12: Angular Forms</strong>&nbsp;</p>
						<ul>
							<li>Template-driven forms</li>
							<li>Reactive forms</li>
							<li>Form Group</li>
							<li>Form Controller</li>
							<li>Form Builder</li>
							<li>Form Array</li>
							<li>Form Validations</li>
							<li>Custom Validations</li>
						</ul>
						<p><strong>Topic 13: Angular CLI</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Installation</li>
							<li>
								Commands
								<ul>
									<li>Creating Components</li>
									<li>Modules</li>
									<li>Services</li>
								</ul>
							</li>
							<li>Build solution</li>
						</ul>
						<p><strong>Topic 14: Angular HTTP Service and HTTP Client</strong></p>
						<ul>
							<li>Observables</li>
							<li>Promise</li>
							<li>
								Http Requests
								<ul>
									<li>GET</li>
									<li>PUT</li>
									<li>POST</li>
								</ul>
							</li>
							<li>Configuring headers</li>
							<li>Interceptors</li>
							<li>Progress events</li>
						</ul>
						<p><strong>Topic 15: Angular Router and Navigation</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Setting up the router&nbsp; Navigation</li>
							<li>Route module and Service</li>
							<li>Child routes</li>
							<li>Routing Params</li>
						</ul>
						<p><strong>Topic 16: Angular Lazy loading</strong></p>
						<ul>
							<li>Introduction</li>
							<li>
								Design Lazy loading
								<ul>
									<li>Define Module</li>
									<li>Define Routes</li>
								</ul>
							</li>
						</ul>
						<p><strong>Topic 17: Angular Route Guards and Hooks</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Design Guards</li>
							<li>Navigation Popups</li>
						</ul>
						<p><strong>Topic 18: Ahead of Time Compiler</strong> <strong>(AOT)</strong></p>
						<p><strong>Topic 19: Production Mode</strong></p>
						<p><strong>Angular Versions</strong> <strong>And Features</strong></p>
						<p><strong>AngularJS:</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Architecture</li>
							<li>Folder Structure</li>
							<li>Controllers</li>
							<li>Modules</li>
							<li>Scope</li>
							<li>Root Scope</li>
							<li>Routing</li>
						</ul>
						<p><strong>Angular 2:</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Overview</li>
							<li>AngularJS vs Angular 2</li>
							<li>Concepts</li>
							<li>Features</li>
						</ul>
						<p><strong>Angular 4:</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Angular 2 to Angular 4</li>
							<li>Concepts</li>
							<li>Features</li>
						</ul>
						<ul>
							<li>Introducing&nbsp;<span>HttpClient</span></li>
							<li>New&nbsp;<span>router life cycle</span>&nbsp;events for Guards and Resolvers.</li>
							<li>Four new events:&nbsp;
								<ul>
									<li>GuardsCheckStart</li><li>GuardsCheckEnd</li><li>ResolveStart</li>
									<li>ResolveEnd</li>
									<li>join the existing set of life cycle event such as NavigationStart.</li>
								</ul>
							</li>
							<li>Conditionally&nbsp;<span>disable</span>&nbsp;animations.</li>
						</ul>
						<p><strong>Angular 5:</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Angular 4 to Angular 5</li>
							<li>Concepts</li>
							<li>Features</li>
						</ul>
						<p><strong>Angular 6:</strong></p>
						<ul>
							<li>Introduction</li>
							<li>Angular 5 to Angular 6</li>
							<li>Concepts</li>
							<li>Features</li>
							<li>ng update</li>
							<li>ng add</li>
							<li>Angular Elements</li>
							<li>Angular Material + CDK Components</li>
							<li>Angular Material Starter Components</li>
							<li>CLI Workspaces</li>
							<li>Library Support</li>
							<li>Tree Shakable Providers</li>
							<li>Animations Performance Improvements and RxJS v6.</li>
						</ul>
						<p><strong>Angular 7:</strong></p>
						<ul>
							<li>Updates regarding Application Performance<strong></strong></li>
							<li>Angular Material &amp; CDK<strong></strong></li>
							<li>Virtual Scrolling<strong></strong></li>
							<li>Improved Accessibility of Selects, now supports Content Projection using web standard for custom elements<strong></strong></li>
							<li>Dependency updates regarding Typescript 3.1, RxJS 6.3, Node 10 (still supporting Node 8).<strong></strong></li>
						</ul>
						<p><strong>Angular 8:</strong></p>
						<ul>
							<li>Featuring Differential loading for all application code</li>
							<li>Dynamic imports for lazy routes</li>
							<li>Web workers</li>
							<li>Type Script 3.4 support</li>
							<li>&nbsp;Angular Ivy as an opt-in preview</li>
							<li>Angular Ivy opt-in preview includes:</li>
						</ul>
						<ul>
							<li>Generated code that is easier to read and debug at runtime</li>
							<li>Faster re-build time</li>
							<li>Improved payload size</li>
							<li>Improved template type checking</li>
							<li>Backwards compatibility</li>
						</ul>
						<p><strong>Angular 9:</strong></p>
						<ul>
							<li>Version 9 moves all applications to use the&nbsp;Ivy compiler and runtime&nbsp;by default.</li>
							<li>&nbsp;Angular has been updated to work with TypeScript 3.6 and 3.7.</li>
							<li>&nbsp;In addition to hundreds of bug fixes, the Ivy compiler and runtime offers numerous advantages:</li>
						</ul>
						<ul>
							<li>Smaller bundle sizes</li>
							<li>Faster testing</li>
							<li>Better debugging</li>
							<li>Improved CSS class and style binding</li>
							<li>Improved type checking</li>
							<li>Improved build errors</li>
							<li>Improved build times, enabling AOT on by default</li>
							<li>Improved&nbsp;Internationalization</li>
						</ul>
						<p><strong>Angular 10:</strong></p>
						<ul>
							<li>New Date Range Picker (Material UI library)</li>
							<li>Warnings about CommonJS imports</li>
							<li>Optional Stricter Settings</li>
							<li>Keeping Up to Date with the Ecosystem</li>
							<li>New Default Browser Configuration</li>
							<li>Deprecations and Removals</li>
						</ul>
					</div>}
				</article>
				<article>
					<div>
						<header className="entry-header" onClick={() => { setShowJSCourse(!showJSCourse) }}>
							<h1 className="entry-title">
								<span>JavaScript Syllabus</span>
								<span className="fa-caret-down-1"></span>
							</h1>
						</header>
					</div>
					{showJSCourse && <div id="jscontent">
						<JSCourse></JSCourse>
					</div>}
				</article>
				<article>
					<div>
						<header className="entry-header" onClick={() => { setShowHTMLCourse(!showHTMLCourse) }}>
							<h1 className="entry-title">
								<span>HTML Syllabus</span>
								<span className="fa-caret-down-1"></span>
							</h1>
						</header>
					</div>
					{showHTMLCourse && <div id="htmlcontent">
						<HtmlCourse></HtmlCourse>
					</div>}
				</article>
				<article>
					<div>
						<header className="entry-header">
							<h1 className="entry-title" onClick={() => { setShowCSSCourse(!showCSSCourse) }}>
								<span>CSS Syllabus</span>
								<span className="fa-caret-down-1"></span>
							</h1>
						</header>
					</div>
					{showCSSCourse && <div id="csscontent" className="display:none;">
						<CSSCourse></CSSCourse>
					</div>}
				</article>
				<article>
					<div>
						<header className="entry-header" onClick={() => { setShowBSCourse(!showBSCourse) }}>
							<h1 className="entry-title">
								<span>BootStrap Syllabus</span>
								<span className="fa-caret-down-1"></span>
							</h1>
						</header>
					</div>
					{showBSCourse && <div id="bscontent" className="display:none;">
						<BSCourse></BSCourse>
					</div>}
				</article>
			</main>
		</>
	);
}